<template>
  <div class="interactive-can-section">
    <ScalingBackground
      class="interactive-can-section__background"
      :class="{
        'interactive-can-section__background--IE': isIE
      }"
      :largeWidth="backgroundLargeWidth"
      :largeHeight="backgroundLargeHeight"
      :smallWidth="backgroundSmallWidth"
      :smallHeight="backgroundSmallHeight"
    />
    <div class="section__content-wrapper">
    <h2 class="interactive-can-section__title">
      {{headline}}
    </h2>
    <p class="interactive-can-section__copy" v-html="body">
    </p>
    <InteractiveCan />

    </div>
  </div>
</template>

<script>
/**
 * Interactive Red Bull can section.
 */
import { mapGetters } from 'vuex';
import {
  CONTENT_CAN_SECTION_HEADLINE,
  CONTENT_CAN_SECTION_BODY,
  SIZE_WIDTH_INTERACTIVE_CAN_SMOKE_LARGE,
  SIZE_WIDTH_INTERACTIVE_CAN_SMOKE_SMALL,
  SIZE_HEIGHT_INTERACTIVE_CAN_SMOKE_LARGE,
  SIZE_HEIGHT_INTERACTIVE_CAN_SMOKE_SMALL
} from '../../design-tokens/build/dictionary';
import InteractiveCan from './../components/interactive-can';
import ScalingBackground from './../components/scaling-background';
import { getNumberFromToken } from '../core/utils';

export default {
  name: 'interactive-can',
  components: {
    InteractiveCan,
    ScalingBackground
  },
  data() {
    return {
      headline: CONTENT_CAN_SECTION_HEADLINE,
      body: CONTENT_CAN_SECTION_BODY,
    };
  },
  computed: {
    backgroundLargeWidth() {
      return getNumberFromToken(SIZE_WIDTH_INTERACTIVE_CAN_SMOKE_LARGE);
    },
    backgroundSmallWidth() {
      return getNumberFromToken(SIZE_WIDTH_INTERACTIVE_CAN_SMOKE_SMALL);
    },
    backgroundLargeHeight() {
      return getNumberFromToken(SIZE_HEIGHT_INTERACTIVE_CAN_SMOKE_LARGE);
    },
    backgroundSmallHeight() {
      return getNumberFromToken(SIZE_HEIGHT_INTERACTIVE_CAN_SMOKE_SMALL);
    },
    ...mapGetters('windowMedia', [
      'isIE'
    ])
  }
};
</script>

<style lang="scss">
$interactive-can-section-ideal-ratio:
  $size-height-interactive-can-section-large / $size-width-interactive-can-section-large;
$interactive-can-section-ideal-ratio-small:
  $size-height-interactive-can-section-small / $size-width-interactive-can-section-small;

.interactive-can-section {
  z-index: $z-index-section-with-bkg;
  text-align: center;
  min-height: $interactive-can-section-ideal-ratio * $size-width-grid-full-medium;
  margin: $size-margin-top-interactive-can-section-large 0 $size-margin-bottom-interactive-can-section-large;
  padding: $size-padding-top-interactive-can-section-large 0 $size-padding-bottom-interactive-can-section-large;

  @include global-media(small) {
    min-height: $interactive-can-section-ideal-ratio-small * $size-width-grid-full-small;
    margin: $size-margin-top-interactive-can-section-small 0 $size-margin-bottom-interactive-can-section-small;
    padding: $size-padding-top-interactive-can-section-small 0 $size-padding-bottom-interactive-can-section-small;
  }
  .section__content-wrapper {
    min-height: 100%;
  }

  &__title {
    @include heading-2;
    @include grid-block($columns: 7, $medium-columns: 9);
    margin: auto;
  }
  &__copy {
    @include body-copy-small;
    @include grid-block($columns: 7, $medium-columns: 9);
    margin:
      $size-margin-top-interactive-can-section-copy-large
      auto
      $size-margin-bottom-interactive-can-section-copy-large;
    @include global-media(small) {
      margin:
        $size-margin-top-interactive-can-section-copy-small
        auto
        $size-margin-bottom-interactive-can-section-copy-small;
    }
  }

  .interactive-can {
    &__flex-container {
      margin:
        $size-margin-top-interactive-can-section-can-large
        auto
        $size-margin-top-interactive-can-section-can-large;
      @include global-media(small) {
        margin:
          $size-margin-top-interactive-can-section-can-small
          auto
          $size-margin-bottom-interactive-can-section-can-small;
      }
    }

    &__image-slider {
      @include grid-block($columns: 5, $small-columns: 3);
    }
  }

  &__background {
    background-image: url('./../assets/images/can-bkg.png');
    top: 50%;
    transform: translateY(-50%);
      &--IE {
        height: 80vw;
        min-height: 1650px;
        @include media(large) {
          height: 80vw;
          min-height: 1250px;
        }
        @include media(medium) {
          height: 95vw;
          min-height: 0px;
        }
        @include media(small) {
          height: 95vw;
          min-height: 500px;
        }
      }
  }
}
</style>
